module.exports = __webpack_public_path__ + "img/bg-image-11.0e68fd10.jpg";